import { render, staticRenderFns } from "./OssDownloadTable.vue?vue&type=template&id=104e73ca"
import script from "./OssDownloadTable.vue?vue&type=script&lang=ts"
export * from "./OssDownloadTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports